<div [formGroup]="group" [class.form-group]="!group.disabled" style="display: flex" class="row">

  <label *ngIf="config.options.labelShowInDetail && (group.enabled || config.presentation === 'filter' || config.presentation === 'detail')
                || (config.presentation === 'edit' && config.options.labelShowInDetail)"
         for="{{config.label}}" class="col-sm-3 control-label">{{config.label | translate:locale.language}}</label>


    <div class="parent-container" [ngClass]="config.options.labelShowInDetail ? 'col-sm-9' : 'col-sm-12'">

      <!--  normal form  -->
      <div *ngIf="group.enabled && config.presentation === 'edit'" style="width: 100%; float: right;">
        <textarea [class.control-disabled]="isEnabled" style="resize: none"
                  ctrl-error
                  formControlName="{{config.controlName[0]}}"
                  class="form-control formControlName-container"
                  id="{{config.label}}"
                  rows="{{config?.options.rows ? config?.options.rows : 13}}">
        </textarea>
       </div>

      <!-- presentation form  -->
      <div *ngIf="(group.disabled && getValue) || config.presentation === 'detail'" style="width: 100%;" id="{{config.label}}">
        <label #comment  class="scroll-bar" style="margin-bottom: 11px;font-weight: bold;white-space: pre-wrap;max-height: 350px;overflow-y: auto;width:100%;"
               [innerHTML]="getValue">
        </label>
      </div>

      <!-- errors form -->
      <span [class.hideStar]="config.presentation === 'detail'" >
         <span *ngIf="group.get([config.controlName[0]]).invalid && !group.get([config.controlName[0]]).value" class="icon-mandatory">*</span>
      </span>

    </div>

</div>
